
define('jsx!components/react-ad/helper',['underscore', 'react', 'jsx!components/react-ad/main', 'jsx!components/lists/content-marketing'], function(_, React, Ad, AdNative) {
    'use strict';

    return function renderComponent(element, config) {
        if (!element) {
            return;
        }

        config = config || {};

        if (config.native) {
            var data = _.mapKeys(config.native, function(el, key) {
                return _.camelCase(key);
            });
            var url = data.link && data.link.url ? data.link.url : data.clickUrl;
            var clickTrackers = null;

            if (data.link && data.link.click_trackers) {
                clickTrackers = data.link.click_trackers;
            } else if (data.clickTrackers && data.clickTrackers.length > 0) {
                clickTrackers = data.clickTrackers;
            }

            var artId = url.lastIndexOf('/');

            config.native = [{
                id: url.substring(artId + 1),
                title: data.title,
                url: url,
                logo: data.icon ? data.icon.url : null,
                provider: data.sponsored ? data.sponsored : data.sponsoredBy,
                image: data.mainImg ? data.mainImg.url : data.image.url,
                type: data.desc2 || '',
                impressionTrackers: data.impressionTrackers ? data.impressionTrackers : data.impression_trackers,
                javascriptTracker: data.javascriptTrackers ? data.javascriptTrackers : data.javascript_trackers,
                clickTrackers: clickTrackers
            }];

            return AdNative(element, config);
        } else {
            React.render(React.createElement(Ad, React.__spread({},  config)), element);
        }
    };
});

